import React, {useEffect, useState} from "react";
import "./NotificationPanel.sass";
import NotificationItem from "./NotificationItem";
import {useDispatch, useSelector} from "react-redux";
import _ from "lodash";
import {readNotification} from "../../../_actions/notification/notificationService";

export default function NotificationPanel({show, onHide}) {
    const [hidden, setHidden] = useState(true);
    const {data: notifications} = useSelector(state => state.notification.getNotifications);

    const dispatch = useDispatch();

    useEffect(() => {
        if (show) {
            setHidden(false);
        }
    }, [show])

    const handleClick = () => {
        setHidden(true)
        setTimeout(() => {
            onHide();
        }, 200)
    }

    if (!show) {
        return <></>
    }

    const handleMouseEnter = (id) => {
        dispatch(readNotification(id))
    }

    return (
        <div className="NotificationPanel-wrapper" onClick={handleClick}>
            <div className={`NotificationPanel-content  ${!hidden && "NotificationPanel-content-visible"}`}
                 onClick={(e) => e.stopPropagation()}>
                <div className="NotificationPanel-content-title">Сообщения</div>
                {
                    _.isEmpty(notifications)
                        ? <div className="NotificationPanel-content-empty">нет сообщений</div>
                        : notifications.map(n => <NotificationItem key={`notification-${n.id}`}
                                                                   onMouseEnter={() => handleMouseEnter(n.id)}
                                                                   notification={n}/>)
                }
            </div>
        </div>
    )
}
